import React from 'react'
import Navigation from 'components/common/Navigation/Navigation'
import GuardedRoute from './guardedRoute'
import UnguardedRoute from './unguardedRoute'

const withNav = navProps => Component => ({ ...props }) => {
    return (
        <>
            <Navigation {...navProps} />
            <Component {...props} />
        </>
    )
}

const GenericRoute = ({ component: Component, nav, dark, transparent, home, guarded, ...rest }) => {
    const RenderedComponent = nav
        ? withNav({ dark, position: nav || 'fixed', transparent, home })(Component)
        : ({ ...props }) => <Component {...props} />

    return guarded ? (
        <GuardedRoute render={RenderedComponent} {...rest} />
    ) : (
        <UnguardedRoute render={RenderedComponent} {...rest} />
    )
}

export default GenericRoute
